import React, { useState } from 'react';
import './EditInvestorDialog.css';
import API_URL from '../config';

const EditInvestorDialog = ({ investor, isOpen, onClose, onSave, investorType }) => {
  const [formData, setFormData] = useState({
    investorName: investor?.investorName || '',
    firmName: investor?.firmName || '',
    linkedinProfile: investor?.linkedinProfile || '',
    email: investor?.email || '',
    contactNumber: investor?.contactNumber || '',
    stage: investor?.stage || '',
    industry: investor?.industry || '',
    skills: investor?.skills?.join(', ') || ''
  });

  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!formData.email || !formData.contactNumber) {
      setError('Email and contact number are required');
      return;
    }

    const updatedData = {
      ...formData,
      skills: formData.skills.split(',').map(skill => skill.trim()).filter(Boolean)
    };

    try {
      const response = await fetch(`${API_URL}/api/investors/${investor._id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(updatedData)
      });

      if (!response.ok) throw new Error('Failed to update investor');

      const result = await response.json(); // Ensure you get the updated investor from API
      if (result.data) {
        onSave(result.data); // Use the correct field from API response
      }

      onClose(); // Close modal
    } catch (error) {
      setError('Failed to update investor. Please try again.');
    }
  };



  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">Edit Investor Details</h2>
        </div>

        <form onSubmit={handleSubmit} className="modal-form">
          {error && <div className="error-message">{error}</div>}

          {investorType === 'angel' ? (
            <div className="form-group">
              <label className="form-label">Investor Name</label>
              <input
                className="form-input"
                type="text"
                name="investorName"
                value={formData.investorName}
                onChange={handleChange}
              />
            </div>
          ) : (
            <div className="form-group">
              <label className="form-label">Firm Name</label>
              <input
                className="form-input"
                type="text"
                name="firmName"
                value={formData.firmName}
                onChange={handleChange}
              />
            </div>
          )}

          <div className="form-group">
            <label className="form-label">LinkedIn Profile</label>
            <input
              className="form-input"
              type="url"
              name="linkedinProfile"
              value={formData.linkedinProfile}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label className="form-label">Email</label>
            <input
              className="form-input"
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label className="form-label">Contact Number</label>
            <input
              className="form-input"
              type="tel"
              name="contactNumber"
              value={formData.contactNumber}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label className="form-label">Investment Stage</label>
            <input
              className="form-input"
              type="text"
              name="stage"
              value={formData.stage}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label className="form-label">Industry</label>
            <input
              className="form-input"
              type="text"
              name="industry"
              value={formData.industry}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label className="form-label">Skills (comma-separated)</label>
            <input
              className="form-input"
              type="text"
              name="skills"
              value={formData.skills}
              onChange={handleChange}
            />
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary"
            >
              Save Changes
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditInvestorDialog;